export default __webpack_public_path__ + "static/media/featured_img_two.0ceb8187.png";